import { render, staticRenderFns } from "./ques-input.vue?vue&type=template&id=45c22423&scoped=true&"
import script from "./ques-input.vue?vue&type=script&lang=js&"
export * from "./ques-input.vue?vue&type=script&lang=js&"
import style0 from "./ques-input.vue?vue&type=style&index=0&id=45c22423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c22423",
  null
  
)

export default component.exports